import { useCookie, useRequestHeaders } from "#imports";
import { createIdentificationUniqueId } from "../helpers/createIdentificationUniqueId.js";
const HEADER_NAME = "bm-visitor-id";
const COOKIE_NAME = "visitor_id";
const COOKIE_EXPIRATION_SECONDS = 34190208;
export function useVisitorId(settings = { forceRefresh: false }) {
  const headers = useRequestHeaders();
  if (headers[HEADER_NAME]) {
    return headers[HEADER_NAME];
  }
  const cookie = useCookie(COOKIE_NAME, {
    default: () => createIdentificationUniqueId(),
    maxAge: COOKIE_EXPIRATION_SECONDS,
    secure: true
  });
  if (settings.forceRefresh) {
    const backup = cookie.value;
    cookie.value = "";
    cookie.value = backup;
  }
  return cookie.value;
}
